// extracted by mini-css-extract-plugin
export default {"close-edit-panel-icon":"EstimateDocument_close-edit-panel-icon__TodIE"};